module.exports = __webpack_public_path__ + "img/9791195966202.4662b813.jpg";